<template>
  <div class="mt-3" :class="{ 'iframe-mode': isInIframe }">
    <v-toolbar flat color="white" class="elevation-1">
      <v-toolbar-title :class="primaryTextClass" class="text-zt-xl">
        <zt-icon name="book-brain" class="pb-2 mt-1 pr-1"></zt-icon>
        <span class="ml-1">{{
          $t('message.LicensesHistoryComponent.tabs.licenses.title')
        }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="inline-flex w-64">
        <v-select
          class="ml-2 pt-3"
          :items="orderBy"
          clearable
          :placeholder="$t('message.LicensesManager.orderBy')"
          item-text="label"
          item-value="value"
          v-model="columnSelected"
          @change="orderList()"
          solo
          flat
          data-vs-select="orderby"
        ></v-select>
        <button
          class="order-button"
          @click="pagination.descending = !pagination.descending"
        >
          <zt-icon
            :name="pagination.descending ? 'arrow-down-2' : 'arrow-up'"
            class="pt-2"
            :class="primaryTextClass"
          />
        </button>
      </div>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="historyList"
      item-key="id"
      class="elevation-1"
      :expand="expand"
      :rows-per-page-items="[8, 15, 30]"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
    >
      <template v-slot:no-data>
        <div class="flex flex-col justify-center items-center py-12">
          <div class="h-40">
            <graphic-base height="100%" width="100%" :viewBox="'0 0 160 120'">
              <EmptyStateSVG />
            </graphic-base>
          </div>
          <p :class="primaryTextClass" class="text-base leading-5 pt-4 font-normal">
            {{ $t('message.LicensesHistoryComponent.tabs.licenses.emptyHistory') }}
          </p>
        </div>
      </template>
      <template v-slot:items="props">
        <tr @mouseover="selectItem(props.item.id)" @mouseleave="unSelectItem()">
          <td
            @click="props.expanded = !props.expanded"
            class="cursor-pointer"
            data-vs-button="selectItem"
          >
            <zt-icon :name="props.expanded ? 'angle-down' : 'angle-right'" />
          </td>
          <td>
            <p :class="primaryTextClass" class="text-zt-base font-bold">
              {{ props.item.tipo_alias }}
            </p>
            <p :class="getStatusClass(props.item.estado_id, props.item.estado_alias)">
              {{ getStatus(props.item) }}
            </p>
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ getApprover(props.item) }}
            <span v-if="props.item.solicita_anticipo === 't' && hasVPI"
              ><br />{{ $t('message.dashboard.salaryAdvance.requested') }}</span
            >
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ woTime(props.item.fecha) }}
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ props.item.fecha_desde }}
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ props.item.fecha_regreso }}
          </td>
          <td class="text-zt-base text-zt-dark-500">
            <template
              v-if="
                selectedItem == props.item.id &&
                  (props.item.estado_id == 2 ||
                    props.item.estado_id == 3 ||
                    props.item.estado_id == 4)
              "
            >
              <button
                @click="cancelLicense(props.item.id)"
                data-vs-button="cancelLicense"
              >
                <zt-icon
                  :class="primaryTextClass"
                  class="text-zt-lg"
                  name="trash-outline cursor-pointer"
                />
              </button>
            </template>
            <template v-else>
              {{ props.item.dias }}
            </template>
          </td>
          <td>
            <div class="flex content-center items-center">
              <button
                @click="openGoogleCalendar(props.item)"
                data-vs-button="openGoogleCalendar"
                v-if="props.item.estado_id == 5 && !props.item.sync_origin"
              >
                <zt-icon
                  :class="primaryTextClass"
                  class="text-zt-lg  mr-1"
                  name="calendar-num cursor-pointer"
                />
              </button>
              <zt-tooltip
                v-if="props.item.upload_document === 't' && !props.item.sync_origin"
                text="Cargar archivo"
                position="left"
              >
                <button
                  @click="openUploadFileModal(props.item)"
                  class="flex align-center"
                  data-vs-button="openFileUpload"
                >
                  <zt-icon
                    :class="primaryTextClass"
                    class="text-zt-lg pb-1 "
                    name="plus-circle cursor-pointer"
                  />
                </button>
              </zt-tooltip>
              
              <button
                v-else-if="props.item.license_has_document === 't' && !props.item.sync_origin"
                class="pointer order-button"
                :class="primaryTextClass"
                @click="downloadDocument(props.item.id)"
                data-vs-button="download"
              >
                <zt-icon
                  name="download-paper-outline"
                  class="text-zt-lg"
                ></zt-icon>
              </button>

                <button
                  @click="openHolidaysModal(props.item)"
                  class="flex align-center mx-1"
                  data-vs-button="openFileUpload"
                  v-if="props.item.type_id_vp === '2' && hasVPI"
                >
                  <zt-icon
                    :class="primaryTextClass"
                    class="text-zt-lg pb-1 "
                    name="list-ul cursor-pointer"
                  />
                </button>
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text>
            <div class="flex justify-between">
              <div>
                <span class="font-bold"
                  >{{
                    $t(
                      'message.LincensesHistorySummaryComponent.labels.comment'
                    )
                  }}:
                </span>
                <p v-html="props.item.observaciones"></p>
              </div>

              <button
                v-if="props.item.license_has_document === 't' && !props.item.sync_origin"
                class="pointer order-button"
                :class="primaryTextClass"
                @click="downloadDocument(props.item.id)"
                data-vs-button="download"
              >
                <zt-icon
                  name="download-paper-outline"
                  class="mr-2 text-zt-xl"
                ></zt-icon>
                <span class="border-b" :class="'border-' + (isInIframe ? 'iframe-primary' : 'zt-primary-200')">{{
                  $t('message.LicensesHistoryComponent.downloadDocument')
                }}</span>
              </button>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <AddFileModal
      :activeModal="activeModal"
      :licenceId="selectedItemId"
      @updateList="updateList"
      @close="activeModal = !activeModal"
      @update:linkUsersModalActive="linkUsersModalActive = $event"
    />
     <HolidaysByPeriodModal
      :activeModal="activeHolidaysModal"
      :licenceId="selectedItemId"
      @close="activeHolidaysModal = !activeHolidaysModal"
    />
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import SichernPeople from '@/apiClient/SichernIntegration'
import AddFileModal from './AddFileModal.vue'
import HolidaysByPeriodModal from './HolidaysByPeriodModal.vue'
import { find } from 'lodash'
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import EmptyStateSVG from '@/components/commons/Illustrations/graphicSVG/graphicEmptyState'

export default {
  components: {
    AddFileModal,
    HolidaysByPeriodModal,
    graphicBase,
    EmptyStateSVG
  },
  inject: ['state', 'mutations'],
  props: {
    history: {
      type: Array,
      default: []
    },
    totalItems: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      licenses: Licenses,
      sichernPeople: SichernPeople,
      historyList: this.history,
      historyTotal: this.totalItems,
      loading: false,
      selectedItem: false,
      selectedItemId: '',
      columnSelected: '',
      orderBy: [
        {
          value: 'type',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.licenseType'
          )
        },
        {
          value: 'status',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.status'
          )
        },
        {
          value: 'approver',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.approver'
          )
        },
        {
          value: 'date',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.request'
          )
        },
        {
          value: 'dateFrom',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.startDate'
          )
        },
        {
          value: 'dateTo',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.return'
          )
        },
        {
          value: 'days',
          label: this.$t('message.LincensesHistorySummaryComponent.labels.days')
        }
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 8,
        sortBy: null,
        totalItems: this.historyTotal
      },
      expand: false,
      headers: [
        { text: '', sortable: false },
        {
          text: `
            ${this.$t(
              'message.LincensesHistorySummaryComponent.labels.licenseType'
            )}/
            ${this.$t(
              'message.LincensesHistorySummaryComponent.labels.status'
            )}`,
          align: 'left',
          sortable: false,
          value: 'tipo_alias',
          class: ['column-header']
        },
        {
          text: this.$t(
            'message.LincensesHistorySummaryComponent.labels.approver'
          ),
          sortable: false,
          align: 'left',
          value: 'en_manos_de',
          class: ['column-header']
        },
        {
          text: this.$t(
            'message.LincensesHistorySummaryComponent.labels.request'
          ),
          sortable: false,
          align: 'left',
          value: 'fecha',
          class: ['column-header']
        },
        {
          text: this.$t(
            'message.LincensesHistorySummaryComponent.labels.startDate'
          ),
          sortable: false,
          align: 'left',
          value: 'fecha_desde',
          class: ['column-header']
        },
        {
          text: this.$t(
            'message.LincensesHistorySummaryComponent.labels.return'
          ),
          sortable: false,
          align: 'left',
          value: 'fecha_regreso',
          class: ['column-header']
        },
        {
          text: this.$t('message.LincensesHistorySummaryComponent.labels.days'),
          sortable: false,
          align: 'left',
          value: 'dias',
          class: ['column-header']
        },
        {
          text: this.$t('message.LincensesHistorySummaryComponent.labels.action'),
          sortable: false,
          align: 'left',
          value: '',
          class: ['column-header']
        }
      ],
      activeModal: false,
      activeHolidaysModal: false,
      sichernPeople:SichernPeople,
      holidayDetails: {}, // Mapa de id de licencia -> detalles de períodos
      loadingDetails: {} // Mapa de id de licencia -> estado de carga
    }
  },
  created() {
    this.licenses = new Licenses()
    this.sichernPeople = new SichernPeople()
  },
  computed: {
    isInIframe() {
      return window.self !== window.top;
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    },
    setColorByStatus() {
      return id => {
        const stringId = String(id)
        const config = [
          { id: '2', fontColor: 'text-zt-warning' },
          { id: '3', fontColor: 'text-zt-warning' },
          { id: '4', fontColor: 'text-zt-warning' },
          { id: '5', fontColor: 'text-zt-success' },
          { id: '8', fontColor: 'text-zt-danger' },
          { id: '9', fontColor: 'text-zt-dark-400' },
          { id: '10', fontColor: 'text-zt-dark-400' }
        ]
        const response = find(config, { id: stringId })
        return response ? response.fontColor : 'text-zt-dark-400'
      }
    },
    getStatusClass() {
      return (id, statusText) => {
        const stringId = String(id)
        // Si estamos en iframe, cambiar solo los colores dark (morado/gris) a azul
        // Mantener: warning (naranja), success (verde), danger (rojo)
        if (this.isInIframe) {
          // Estados 9, 10 usan dark-400 (Cancelada/Vencida) -> cambiar a azul
          if (['9', '10'].includes(stringId)) {
            return 'text-iframe-primary'
          }
          // Si no tiene color definido en config (default dark-400), también cambiar a azul
          const definedStates = ['2', '3', '4', '5', '8', '9', '10']
          if (!definedStates.includes(stringId)) {
            return 'text-iframe-primary'
          }
        }
        // Si no, usar los colores normales
        return this.setColorByStatus(id)
      }
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getHistoryLicenses()
      },
      deep: true
    },
    'state.updateData'(newVal, oldVal) {
      if (newVal) {
        this.pagination = {
          descending: true,
          page: 1,
          rowsPerPage: 8,
          sortBy: null,
          totalItems: this.historyTotal
        }
        this.getHistoryLicenses()
        this.mutations.updateHistory(false)
      }
    }
  },
  methods: {
    handleExpandRow(props) {
      const wasExpanded = props.expanded;
      props.expanded = !props.expanded;
      if (!wasExpanded && props.expanded && this.hasVPI) {
        this.viewHolidayDetailsVP(props.item.id);
      }
    },
    openUploadFileModal(item) {
      this.selectedItemId = item.id
      let fakemetadata = {
        id: item.id,
        id_template: 1,
        json: {
          name: 'GEN',
          alias: 'Generico',
          files: [
            {
              hash: '',
              name: 'Generico',
              alias: 'Generico',
              order: 10,
              value: '',
              mimeType: '',
              mandatory: true
            }
          ],
          max_files: 20,
          min_files: 1,
          version_name: 'CE1',
          version_number: 1
        },
        name: 'CERTIFICADOS DE LICENCIAS'
      }
      this.mutations.setUploadFilesMetaData(fakemetadata)
      this.activeModal = !this.activeModal
    },
    openHolidaysModal(item) {
      this.selectedItemId = item.id
      this.activeHolidaysModal = !this.activeHolidaysModal
    },
    updateList() {
      this.pagination = {
        descending: true,
        page: 1,
        rowsPerPage: 8,
        sortBy: null,
        totalItems: this.historyTotal
      }
      this.loading = true
      this.getHistoryLicenses().finally(() => {
        this.loading = false
      })
    },
    openGoogleCalendar(event) {
      const eventTitle = event.tipo_alias
      const startDate = this.formatDate(event.fecha_desde)
      const endDate = this.formatDate(event.fecha_regreso)

      const calendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startDate}/${endDate}`

      window.open(calendarUrl, '_blank')
    },

    formatDate(date) {
      const [day, month, year] = date.split('/')
      const dateObj = new Date(Date.UTC(year, month - 1, day))

      const formattedYear = dateObj.getUTCFullYear()
      const formattedMonth = String(dateObj.getUTCMonth() + 1).padStart(2, '0')
      const formattedDay = String(dateObj.getUTCDate()).padStart(2, '0')

      return `${formattedYear}${formattedMonth}${formattedDay}`
    },
    customErrorMessges(error) {
      const err = error.response.data.response_v2
      const code =
        err.code === 'La licencia no puede comenzar un dia feriado.'
          ? '02101'
          : err.code
      const message = err.message
      const sichernPeopleErrorCodeRegex = /^SICHERN_PEOPLE_[A-Z_]*_ABSENCE_BAD_REQUEST$/g.test(
        code
      )
      const handledMessages = [
        'StatusNotAllowed',
        'ProcessedAbsenceExists',
        'AbsenceNotExists',
        'AbsenceStatusNotValidForOperation',
        'ErrorDeletingReviewStatus',
        'OnlyRejectedTheLastOpeningAbsence',
        'InvalidDateRange'
      ]
      if (
        sichernPeopleErrorCodeRegex &&
        handledMessages.some(x => x == message)
      ) {
        return `${code}_${message}`
      } else {
        return code
      }
    },
    woTime(value) {
      if (value === null) return ''
      return value.split(' ')[0]
    },
    getStatus(item) {
      if (
        item.estado_id === '2' ||
        item.estado_id === '3' ||
        item.estado_id === '4'
      ) {
        return this.$t('message.LicensesHistoryComponent.statusPending')
      } else if (item.estado_id === '9') {
        return this.$t('message.LicensesHistoryComponent.statusExpired')
      } else {
        return item.estado_alias
      }
    },
    getApprover(item) {
      if (item.estado_id === '4') {
        return 'RRHH'
      } else {
        return item.en_manos_de
      }
    },
    getHistoryLicenses() {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination

      this.licenses
        .getHistoryLicenses(rowsPerPage, page, sortBy, descending)
        .then(response => {
          this.historyList = response.data.results.data
          this.historyTotal = response.data.pagination.total
          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    },
    orderList() {
      this.pagination.sortBy = this.columnSelected
    },
    selectItem(item) {
      this.selectedItem = item
    },
    unSelectItem() {
      this.selectedItem = false
    },
    downloadDocument(licenseId) {
      this.licenses
        .getUploadedDocument(licenseId)
        .then(res => {
          const data_uri_prefix = 'data:application/pdf;base64,'
          const contentDisposition = res[0].headers['content-disposition']
          const filename = contentDisposition
            .split(';')[1]
            .split('=')[1]
            .replace('"', '')
            .replace('"', '')
          this.pdfFile = data_uri_prefix + res[1]
          this.pdfFileName = filename
        })
        .then(() => {
          const element = document.createElement('a')
          element.setAttribute('href', this.pdfFile)
          element.setAttribute('download', this.pdfFileName)
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)
        })
    },
    cancelLicense(licenseId) {
      this.$swal({
        title: this.$t('message.LincensesHistorySummaryComponent.modals.title'),
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        buttonsStyling: false,
        cancelButtonClass: 'btn buttonSwallCancelProperties',
        confirmButtonClass: 'btn buttonSwallConfirmProperties',
        showLoaderOnConfirm: false,
        cancelButtonText: this.$t('message.HeaderComponent.logout.no'),
        confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
      }).then(result => {
        if (result.value) {
          this.licenses
            .deleteRequestLicense(licenseId)
            .then(() => {
              this.$swal({
                type: 'success',
                title: this.$t(
                  'message.LincensesHistorySummaryComponent.sumary.quitLicenseOk'
                ),
                timer: this.$store.getters.getTimerSweetAlert,
                showConfirmButton: false
              }).then(() => {
                this.pagination = {
                  descending: true,
                  page: 1,
                  rowsPerPage: 8,
                  sortBy: null,
                  totalItems: this.historyTotal
                }
                this.getHistoryLicenses()
              })
            })
            .catch(error => {
              this.$swal({
                type: 'error',
                title: this.$t(
                  `message.errorReference.${this.customErrorMessges(error)}`
                ),
                showConfirmButton: true,
                confirmButtonText: this.$t(
                  'message.settingsComponent.list.okMsg'
                )
              })
            })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.column-header {
  font-size: 0.875rem !important;
  color: #969696 !important;
}
.order-button {
  outline: none;
}
::v-deep table.v-table {
  thead th:first-child {
    padding: 0 0 0 14px;
  }
  tbody td:first-child {
    padding: 0 0 0 14px;
  }
}

.text-iframe-primary {
  color: #2694fc !important;
}

.iframe-mode {
  ::v-deep .v-datatable .v-progress-linear {
    background-color: rgba(38, 148, 252, 0.3) !important;
    
    .v-progress-linear__bar__indeterminate {
      .long, .short {
        background-color: #2694fc !important;
      }
    }
    
    .v-progress-linear__bar__determinate {
      background-color: #2694fc !important;
    }
  }
  
  ::v-deep .v-datatable__actions {
    .v-select {
      .v-input__slot {
        color: inherit !important;
      }
      
      .v-select__selection {
        color: inherit !important;
      }
    }
  }
  
  // Estilos para zt-icon en toolbar
  ::v-deep .zt-icon {
    color: #2694fc !important;
  }
}

// Clase para borde azul en iframe
.border-iframe-primary {
  border-color: #2694fc !important;
}

// Fix global para la lista desplegable del paginador - solo el ítem activo
::v-deep .v-menu__content {
  .v-list__tile--active {
    color: #2694fc !important;
    
    .primary--text {
      color: #2694fc !important;
    }
  }
}
</style>
